var $bee07513333bdc15$exports = {};
$bee07513333bdc15$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Vrednost mora biti ".concat(args.maxValue, " ali starej\u0161a.");
  },
  "rangeReversed": "Za\u010Detni datum mora biti pred kon\u010Dnim datumom.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Vrednost mora biti ".concat(args.minValue, " ali novej\u0161a.");
  },
  "unavailableDate": "Izbrani datum ni na voljo."
};
export { $bee07513333bdc15$exports as default };